import request from '@/utils/request'

let PackingApi = {
    /*获取数据*/
    copy(data) {
        return request._get('/shop/plus.packing.packing/copy', data);
    },
    /*获取数据库操作*/
    data(data) {
        return request._get('/shop/plus.packing.packing/data', data);
    },
    /*文件处理*/
    file(data) {
        return request._get('/shop/plus.packing.packing/file', data);
    },

}
export default PackingApi;



// WEBPACK FOOTER //
// ./src/api/packing.js